// Portuguese lines as they should sound. The voices read digits in the masculine ("um série", "dois repetições")
// and say "haltêres", so before a line is spoken: numbers in front of a feminine word are written out in the
// feminine ("uma série", "duas repetições", "vinte e uma repetições"), and a few words are respelled for the ear only.

const UNITS_M = ['zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
const UNITS_F = ['zero', 'uma', 'duas', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
const TEENS = ['dez', 'onze', 'doze', 'treze', 'catorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const TENS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const HUNDREDS = ['', 'cento', 'duzent', 'trezent', 'quatrocent', 'quinhent', 'seiscent', 'setecent', 'oitocent', 'novecent'];

// Words after a number that take the feminine: what the guided workout and the tips count
const FEMININE_NOUNS = /^(séries?|repetiç(ão|ões)|vez(es)?|voltas?|rodadas?|semanas?|horas?|calorias?|refeições|refeição)$/i;

const belowThousand = (n, feminine) => {
  const units = feminine ? UNITS_F : UNITS_M;
  if (n < 10) return units[n];
  if (n < 20) return TEENS[n - 10];
  if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? ` e ${units[n % 10]}` : '');
  if (n === 100) return 'cem';
  const hundreds = Math.floor(n / 100);
  const head = hundreds === 1 ? 'cento' : `${HUNDREDS[hundreds]}${feminine ? 'as' : 'os'}`;
  return n % 100 ? `${head} e ${belowThousand(n % 100, feminine)}` : head;
};

/** 0–999999 in words, feminine or masculine: numberWords(21, true) → "vinte e uma" */
export const numberWords = (n, feminine = false) => {
  if (n < 1000) return belowThousand(n, feminine);
  const thousands = Math.floor(n / 1000);
  const rest = n % 1000;
  const head = thousands === 1 ? 'mil' : `${belowThousand(thousands, feminine)} mil`;
  if (!rest) return head;
  return `${head}${rest < 100 || rest % 100 === 0 ? ' e ' : ' '}${belowThousand(rest, feminine)}`;
};

// Spelled for the ear: what each voice gets wrong
const RESPELLINGS = [[/\bhalteres\b/gi, (word) => (word[0] === 'H' ? 'Haltéres' : 'haltéres')], [/\bhaltere\b/gi, (word) => (word[0] === 'H' ? 'Haltére' : 'haltére')]];

/** A Portuguese line as the voice should read it (the screen keeps the written form) */
export const speakablePt = (text) => {
  if (!text) return text;
  let spoken = text.replace(/\b(\d{1,6})(\s+)([\p{L}]+)/gu, (match, digits, space, word) =>
    FEMININE_NOUNS.test(word) ? `${numberWords(Number(digits), true)}${space}${word}` : match
  );
  for (const [pattern, replace] of RESPELLINGS) spoken = spoken.replace(pattern, replace);
  return spoken;
};
